module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/校招长页面.7c53c5ef.png";